"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
require("../../scss/_loading-overlay.scss");
/**
 * @component LoadingOverlay
 * @example
 * return (
 *   <LoadingOverlay whiteBackground />
 * )
 * @param {boolean} whiteBackground whether to set the background to white
 */
var LoadingOverlay = function (props) {
    var whiteBackground = props.whiteBackground;
    return (react_1.default.createElement(react_1.default.Fragment, null, whiteBackground ? (react_1.default.createElement("div", { className: 'loading-overlay' },
        react_1.default.createElement("div", { className: 'main-styles' },
            react_1.default.createElement("div", { className: 'flex' },
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 0, alignItems: "center", justifyContent: "center" },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(material_1.CircularProgress, null))))))) : (react_1.default.createElement("main", { className: 'loading-overlay' },
        react_1.default.createElement("div", { className: 'flex' },
            react_1.default.createElement(material_1.Grid, { container: true, spacing: 0, alignItems: "center", justifyContent: "center" },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(material_1.CircularProgress, null))))))));
};
exports.default = LoadingOverlay;
